export type TaxPayerType = "individual" | "business" | string | undefined;

export interface StepProgress {
  current: number;
  total: number;
}

interface ProgressInput {
  activeStep: number;
  currentAboutUsStep: number;
  taxPayerType: TaxPayerType;
  isExistingClient: boolean;
  countedMainSteps: number;
}

export const getAboutYouStepCount = (
  taxPayerType: TaxPayerType,
  isExistingClient: boolean
): number => {
  if (taxPayerType === "business") {
    return 7;
  }
  return isExistingClient ? 5 : 6;
};

export const getStepProgress = ({
  activeStep,
  currentAboutUsStep,
  taxPayerType,
  isExistingClient,
  countedMainSteps
}: ProgressInput): StepProgress | null => {
  if (activeStep < 0 || activeStep >= countedMainSteps) {
    return null;
  }
  const aboutYouSteps = getAboutYouStepCount(taxPayerType, isExistingClient);
  const total = aboutYouSteps + countedMainSteps - 1;
  const current =
    activeStep === 0
      ? Math.min(currentAboutUsStep + 1, aboutYouSteps)
      : aboutYouSteps + activeStep;
  return { current, total };
};

export const getProgressRatio = (progress: StepProgress | null): number => {
  if (!progress || progress.total <= 0) {
    return 0;
  }
  return Math.min(Math.max(progress.current - 1, 0) / progress.total, 1);
};
